import { Injectable } from '@angular/core';
import { CustomPageResolverService } from 'gung-standard';
import { SjoborgStartpageCustomPageComponent } from '../components/sjoborg-startpage-custom-page/sjoborg-startpage-custom-page.component';

@Injectable({
  providedIn: 'root'
})
export class SjoborgCustomPageResolverService extends CustomPageResolverService {
  public getLayouts(): { name; componentDisplay }[] {
    const layouts = super.getLayouts();
    layouts.push({
      name: 'startpage',
      componentDisplay: SjoborgStartpageCustomPageComponent
    });
    return layouts;
  }
}
